<template>
  <div>
    <div class="text-left">
      <div class="section-icon">😺</div>
    </div>

    <!-- block -->
    <div class="block mt-4">
      <h1>Who am I?</h1>
      <p class="">
        I'm a father, a husband, a web developer, a vegan, and a motorcyclist.
      </p>
    </div>
    <!-- ./ block -->

    <div class="text-center img-gallery mb-3">
      <img src="/img/family1.jpg" class="rounded" />
      <img src="/img/family2.jpg" class="rounded" />
    </div>

    <!-- block -->
    <div class="block">
      <h2>Origin story</h2>
      <p>
        I come from a litte town Brestanica, Slovenia. My sister and I were
        raised by two loving parents, Matjaž and Helena. We did not have much,
        but we always had enough and we always loved each other. We were taught
        from a young age to stick together and work hard for our achievements.
        Nothing falls from the sky.
      </p>

      <p>
        I got my first PC at the age of 14, a day before entering secondary
        school. I wanted to study computers so I entered technologically focused
        high school with an emphasis on Computer science. Here I got to know how
        computers work and wrote my first line of code in Pascal.
      </p>
      <p>
        After finishing high school I studied at University of Ljubljana's
        Faculty of Electrical Engineering, specifically the Multimedia
        Communications course. While visiting the University I wanted to get
        some first-hand experience and put my knowledge to a test. I opened my
        first company and worked while studying.
      </p>

      <div class="text-center img-gallery mb-3">
        <img src="/img/computers1.jpg" class="rounded" height="200" />
        <img src="/img/computers2.jpg" class="rounded" height="200" />
      </div>

      <p>
        Everything started with building simple sites. Free templates and
        WordPress. Then I learned how to transform design into code
        (html/css/js); built my first WordPress module and theme from scratch;
        and then I met e-commerce ...
      </p>
    </div>
    <!-- ./ block -->

    <!-- block -->
    <div class="block">
      <h2>Web development, web anything</h2>
      <p>
        My first venture in <b>e-commerce</b> happened in 2012 when I started
        work in the largest Slovenian online shop
        <a href="https://www.mimovrste.com/" class="exp-link" alt="Mimovrste"
          >Mimovrste</a
        >. I got familiar with
        <b>back end processes, payment systems, and all sorts of integrations</b
        >.
      </p>
      <p>
        In 2014 my friends and I tried our entrepreneurial skills with our
        <b>own start-up</b> called
        <a
          href="https://www.startup.si/en-us/startup-map/startups-scaleups/enolyse"
          class="exp-link"
          alt="Enolyse"
          >Enolyse</a
        >. It was hard work, but we all learned a lot. I got to try
        <b>AngularJS</b> on the front-end and on the back-end we used
        <b>Laravel for API</b>. I was lead developer for the app platfom,
        designing the entire architecture of the app.
      </p>
      <p>
        In 2016 I started working for leading omnichannel, multi-brand, and
        direct-to-consumer electronic retailer in Europe -
        <a
          href="https://www.studio-moderna.com/"
          class="exp-link"
          alt="Studio Moderna"
          >Studio Moderna</a
        >. We were running 125+ stores on a single <b>Magento</b> instance. This
        was also my first experience with working in a
        <b>larger development environment</b> - our www development team
        consisted of roughly 20 developers. At that time I already knew Magento,
        but I really got to know it inside-out while there. I implemented more
        than 20 <b>payment systems</b> in 18 countries.
      </p>
      <p>
        In the beginning of 2018 I was tempted into a leading role in
        <a href="https://www.bolha.com/" class="exp-link" alt="Bolha">Bolha</a>,
        the biggest classifieds portal in Slovenia. I ran a small development
        team, working on three different platforms. I mostly battled
        <b>coordination</b> with product development and <b>sprint planning</b>,
        extinguishing fires between departments and inside the team.
      </p>
    </div>
    <!-- ./ block -->

    <!-- card -->
    <div class="card block bg-light text-center">
      <div class="card-body">
        <h5 class="mb-4">☝️ Want to see how good I would look in your team?</h5>
        <router-link :to="{ name: 'teamMember' }" class="cta text-center"
          >Click Here</router-link
        >
      </div>
    </div>
    <!-- ./ card -->

    <!-- block -->
    <div class="block">
      <h2>Family & other interests</h2>
      <p>
        I've met my wife Veronika and her son Emanuel (age 4) in the beginning
        of 2011 on mIRC. Yeah, you read that right, mIRC. In 2013 we had another
        son Matija Jan. We got married in 2013 - she wasn't planning to ever get
        married, but my charms swept her away 🤭.
      </p>

      <div class="text-center img-gallery mb-3">
        <img src="/img/family3.jpg" class="rounded" height="200" />
        <img src="/img/family4.jpg" class="rounded" height="200" />
      </div>

      <p>
        I passed my motorcycle driving licence and bought my first motorcycle in
        2018. I've been exctatic about motorcycles ever since. In first season I
        did approximately 20.000 kilometers with 2 bikes. I sold my first bike
        mid first season and bought brand new in 2019. My first choice of
        motorcycle brand was Yamaha. First one was FZ-6N and my second was
        Tracer 900 GT. I currently drive Suzuki GSX-S 1000F. It's a beast🤭
      </p>

      <div class="text-center img-gallery mb-3">
        <img src="/img/motorcycle1.jpg" class="rounded" height="200" />
        <img src="/img/motorcycle2.jpg" class="rounded" height="200" />
        <img src="/img/motorcycle3.jpg" class="rounded" height="200" />
        <img src="/img/motorcycle4.jpg" class="rounded" height="200" />
      </div>

      <p>
        My other interests include, but are not limited to:
      </p>
      <ul>
        <li>everything kids related</li>
        <li>gaming (PC, PS4)</li>
        <li>cooking</li>
      </ul>
    </div>
    <!-- ./ block -->
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style>
.img-gallery img {
  height: 320px;
  max-height: 320px;
  padding: 5px;
  border: 1px solid rgba(55, 53, 47, 0.16);
  margin: 5px;
}
</style>
